<template>
  <v-dialog v-model="openModal" width="700px" min-height="400" persistent>
    <v-card>
      <v-card-title>
        <span class="section-title">Uso do sorteio requer assinatura do termo</span>
      </v-card-title>
      <v-card-text>
        <span class="subtitle-font">
          A utilização do módulo de sorteio da Mercafacil agora requer a assinatura de um <b>aditivo de contrato</b>. O aditivo de contrato
          <b>não tem custo adicional</b>. Para solicitar o aditivo, entre em contato com seu consultor Mercafacil. A liberação do módulo será feita após a
          assinatura do aditivo.
        </span>
      </v-card-text>
      <mf-action-buttons
        class="pr-4 pb-4"
        :primary-button="{
          text: 'Fechar',
          action: closeModal,
          isVisible: true,
        }"
      />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RaffleTermWarning',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    openModal: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  methods: {
    closeModal() {
      this.openModal = false
    },
  },
}
</script>
